import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticatedGuard  {
  constructor(private router: Router,private authService: AuthService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
     
    if (this.authService.IsLoggedIn) {
      return true;
    }else{
      this.router.navigate(['login']);
      return false;
    }
  }
}
